import React from 'react';
import { ReactComponent as Admin } from '../images/icons/BM_Admin.svg';
import { ReactComponent as Alerts } from '../images/icons/BM_Alerts.svg';
import { ReactComponent as Brands } from '../images/icons/BM_Brand.svg';
import { ReactComponent as Customers } from '../images/icons/BM_Customers.svg';
import { ReactComponent as Dashboard } from '../images/icons/BM_Dashboard.svg';
import { ReactComponent as Documents } from '../images/icons/BM_Documents.svg';
import { ReactComponent as Facility } from '../images/icons/BM_Facility.svg';
import { ReactComponent as Home } from '../images/icons/BM_Home.svg';
import { ReactComponent as InspectionStatus } from '../images/icons/BM_InspectionStatus.svg';
import { ReactComponent as Inventory } from '../images/icons/BM_Inventory.svg';
import { ReactComponent as JobComments } from '../images/icons/BM_JobComments.svg';
import { ReactComponent as Jobs } from '../images/icons/BM_Jobs.svg';
import { ReactComponent as Leads } from '../images/icons/BM_Leads.svg';
import { ReactComponent as Locations } from '../images/icons/BM_Locations.svg';
import { ReactComponent as StandardText } from '../images/icons/BM_StandardText.svg';
import { ReactComponent as ManageTeam } from '../images/icons/BM_ManageTeam.svg';
import { ReactComponent as ManageUsers } from '../images/icons/BM_ManageUsers.svg';
import { ReactComponent as Measurement } from '../images/icons/BM_Measurement.svg';
import { ReactComponent as NewUserQueue } from '../images/icons/BM_NewUserQueue.svg';
import { ReactComponent as PMP } from '../images/icons/BM_PreventMaint.svg';
import { ReactComponent as ProductQueue } from '../images/icons/BM_ProductQueue.svg';
import { ReactComponent as Quotes } from '../images/icons/BM_Quotes.svg';
import { ReactComponent as Reports } from '../images/icons/BM_Reports.svg';
import { ReactComponent as Sales } from '../images/icons/BM_Sales.svg';
import { ReactComponent as TAE } from '../images/icons/BM_TAE.svg';
import { ReactComponent as Training } from '../images/icons/BM_Training.svg';
import { ReactComponent as TrainingProgress } from '../images/icons/BM_TrainingProgress.svg';
import { ReactComponent as WorkOrders } from '../images/icons/BM_WorkOrders.svg';
import { ReactComponent as ManageProducts } from '../images/icons/BM_ManageProducts.svg';
import { ReactComponent as CloseMenu } from '../images/icons/CloseMenu.svg';

// Building icon component for "View as Facility" menu item
const BuildingIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M10 1.50366H2C1.725 1.50366 1.5 1.72866 1.5 2.00366V14.0037C1.5 14.2787 1.725 14.5037 2 14.5037H4.5V12.0037C4.5 11.4505 4.94688 11.0037 5.5 11.0037H6.5C7.05312 11.0037 7.5 11.4505 7.5 12.0037V16.0037H2C0.896875 16.0037 0 15.1068 0 14.0037V2.00366C0 0.900537 0.896875 0.00366211 2 0.00366211H10C11.1031 0.00366211 12 0.900537 12 2.00366V5.79429C11.4187 6.02866 10.9062 6.39741 10.5 6.85679V2.00366C10.5 1.72866 10.275 1.50366 10 1.50366ZM11 9.50366C11 8.84062 11.2634 8.20474 11.7322 7.7359C12.2011 7.26705 12.837 7.00366 13.5 7.00366C14.163 7.00366 14.7989 7.26705 15.2678 7.7359C15.7366 8.20474 16 8.84062 16 9.50366C16 10.1667 15.7366 10.8026 15.2678 11.2714C14.7989 11.7403 14.163 12.0037 13.5 12.0037C12.837 12.0037 12.2011 11.7403 11.7322 11.2714C11.2634 10.8026 11 10.1667 11 9.50366ZM9 16.0037C9 14.3474 10.3438 13.0037 12 13.0037H15C16.6562 13.0037 18 14.3474 18 16.0037C18 16.5568 17.5531 17.0037 17 17.0037H10C9.44687 17.0037 9 16.5568 9 16.0037ZM5.25 3.25366C5.25 2.97866 5.475 2.75366 5.75 2.75366H6.25C6.525 2.75366 6.75 2.97866 6.75 3.25366V4.25366H7.75C8.025 4.25366 8.25 4.47866 8.25 4.75366V5.25366C8.25 5.52866 8.025 5.75366 7.75 5.75366H6.75V6.75366C6.75 7.02866 6.525 7.25366 6.25 7.25366H5.75C5.475 7.25366 5.25 7.02866 5.25 6.75366V5.75366H4.25C3.975 5.75366 3.75 5.52866 3.75 5.25366V4.75366C3.75 4.47866 3.975 4.25366 4.25 4.25366H5.25V3.25366Z"
            fill="currentColor"
        />
    </svg>
);

const UserShieldIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M8.91564 8.00366C10.0656 8.00366 11 8.93491 11 10.088C11 10.3193 10.8125 10.5037 10.5844 10.5037H5.41877C5.18752 10.5037 5.00314 10.3162 5.00314 10.088C5.00314 8.93804 5.93439 8.00679 7.08752 8.00366H8.92189H8.91564ZM8.00002 7.00366C7.80303 7.00366 7.60798 6.96486 7.42599 6.88948C7.244 6.8141 7.07864 6.70361 6.93936 6.56432C6.80007 6.42503 6.68958 6.25968 6.6142 6.07769C6.53881 5.8957 6.50002 5.70064 6.50002 5.50366C6.50002 5.30668 6.53881 5.11163 6.6142 4.92964C6.68958 4.74765 6.80007 4.58229 6.93936 4.443C7.07864 4.30371 7.244 4.19322 7.42599 4.11784C7.60798 4.04246 7.80303 4.00366 8.00002 4.00366C8.197 4.00366 8.39205 4.04246 8.57404 4.11784C8.75603 4.19322 8.92139 4.30371 9.06068 4.443C9.19996 4.58229 9.31045 4.74765 9.38584 4.92964C9.46122 5.11163 9.50002 5.30668 9.50002 5.50366C9.50002 5.70064 9.46122 5.8957 9.38584 6.07769C9.31045 6.25968 9.19996 6.42503 9.06068 6.56432C8.92139 6.70361 8.75603 6.8141 8.57404 6.88948C8.39205 6.96486 8.197 7.00366 8.00002 7.00366ZM7.17814 15.7287C2.12814 13.3099 0.690641 8.17554 0.518766 4.98804L0.500016 4.37866C0.496891 3.60991 0.946891 2.96616 1.57189 2.65054L7.60939 0.0817871C7.72814 0.0317871 7.86877 0.00366211 8.00002 0.00366211C8.12814 0.00366211 8.26877 0.0349121 8.39064 0.0817871L14.4281 2.65054C15.05 2.96929 15.5031 3.60991 15.4969 4.37866L15.4781 4.98804C15.3063 8.17554 13.8688 13.3099 8.81877 15.7255C8.55002 15.8349 8.29064 15.913 7.99689 15.913C7.70314 15.913 7.44064 15.8349 7.17502 15.7255L7.17814 15.7287ZM2.00002 4.36929L2.01564 4.92866C2.17502 7.82866 3.48439 12.2818 7.80314 14.3599C7.86877 14.3849 7.92814 14.4099 7.99689 14.4099C8.06877 14.4099 8.12814 14.3849 8.19064 14.3599C12.5094 12.2818 13.8188 7.82554 13.9781 4.92866L13.9938 4.36929C13.9938 4.21304 13.8938 4.04741 13.7094 3.96929L8.00002 1.54741L2.28439 3.97241C2.10002 4.05054 2.00002 4.21616 2.00002 4.37241V4.36929Z"
            fill="#404040"
        />
    </svg>
);

const SearchIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className={className}
    >
        <g clipPath="url(#clip0_4825_2380)">
            <path
                d="M11.5 6.50366C11.5 5.17758 10.9732 3.90581 10.0355 2.96813C9.09785 2.03045 7.82608 1.50366 6.5 1.50366C5.17392 1.50366 3.90215 2.03045 2.96447 2.96813C2.02678 3.90581 1.5 5.17758 1.5 6.50366C1.5 7.82974 2.02678 9.10151 2.96447 10.0392C3.90215 10.9769 5.17392 11.5037 6.5 11.5037C7.82608 11.5037 9.09785 10.9769 10.0355 10.0392C10.9732 9.10151 11.5 7.82974 11.5 6.50366ZM10.5344 11.6005C9.42813 12.4787 8.025 13.0037 6.5 13.0037C2.90937 13.0037 0 10.0943 0 6.50366C0 2.91304 2.90937 0.00366211 6.5 0.00366211C10.0906 0.00366211 13 2.91304 13 6.50366C13 8.02866 12.475 9.43179 11.5969 10.538L15.7812 14.7224C16.075 15.0162 16.075 15.4912 15.7812 15.7818C15.4875 16.0724 15.0125 16.0755 14.7219 15.7818L10.5344 11.6005Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_4825_2380">
                <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0 0.00366211)"
                />
            </clipPath>
        </defs>
    </svg>
);

const ArrowUpRightIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        className={className}
    >
        <path
            d="M8.93545 2C9.24717 2 9.49795 2.25078 9.49795 2.5625V8.1875C9.49795 8.49922 9.24717 8.75 8.93545 8.75C8.62373 8.75 8.37295 8.49922 8.37295 8.1875V3.91953L2.95889 9.33594C2.73858 9.55625 2.38233 9.55625 2.16436 9.33594C1.94639 9.11562 1.94404 8.75938 2.16436 8.54141L7.57842 3.12734L3.31045 3.125C2.99873 3.125 2.74795 2.87422 2.74795 2.5625C2.74795 2.25078 2.99873 2 3.31045 2H8.93545Z"
            fill="black"
        />
    </svg>
);

const FilterIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className={className}
    >
        <path
            d="M0 2.30312C0 1.58437 0.584375 1 1.30313 1H14.6969C15.4156 1 16 1.58437 16 2.30312C16 2.60312 15.8969 2.89375 15.7063 3.125L10.5 9.51562V13.9906C10.5 14.5469 10.0469 15 9.49063 15C9.2625 15 9.04063 14.9219 8.8625 14.7812L5.97188 12.4875C5.67188 12.25 5.5 11.8906 5.5 11.5094V9.51875L0.29375 3.125C0.103125 2.89375 0 2.60312 0 2.30312ZM1.71875 2.5L6.83125 8.775C6.94063 8.90937 7 9.075 7 9.25V11.3875L9 12.975V9.25C9 9.07812 9.05937 8.90937 9.16875 8.775L14.2812 2.5H1.71875Z"
            fill="currentColor"
        />
    </svg>
);

const MailIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        className={className}
    >
        <path
            d="M9.07852 9.86192L15.3566 3.58692L11.2191 15.1307L9.07852 9.86192ZM14.2941 2.52755L8.01914 8.80255L2.75039 6.66192L14.2941 2.52755ZM1.19102 7.6463L7.62227 10.2588L10.2348 16.69C10.4004 17.0994 10.8004 17.3682 11.2441 17.3682C11.7035 17.3682 12.1129 17.0807 12.2691 16.6463L17.8316 1.1213C17.941 0.815048 17.8629 0.477548 17.6348 0.246298C17.4066 0.0150476 17.066 -0.0599524 16.7598 0.0494226L1.23164 5.61192C0.797266 5.76817 0.509766 6.17755 0.509766 6.63692C0.509766 7.08067 0.778516 7.48067 1.18789 7.6463H1.19102Z"
            fill="#404040"
        />
    </svg>
);

export const svgIcons = {
    alerts: <Alerts />,
    admin: <Admin />,
    arrowUpRight: <ArrowUpRightIcon />,
    dashboard: <Dashboard />,
    brands: <Brands />,
    building: <BuildingIcon />,
    closeMenu: <CloseMenu />,
    customers: <Customers />,
    documents: <Documents />,
    facility: <Facility />,
    filter: <FilterIcon />,
    home: <Home />,
    leads: <Leads />,
    locations: <Locations />,
    inspectionStatus: <InspectionStatus />,
    inventory: <Inventory />,
    jobs: <Jobs />,
    jobComments: <JobComments />,
    mail: <MailIcon />,
    search: <SearchIcon />,
    standardText: <StandardText />,
    manageTeam: <ManageTeam />,
    measurement: <Measurement />,
    manageUsers: <ManageUsers />,
    newUserQueue: <NewUserQueue />,
    pmp: <PMP />,
    products: <ManageProducts />,
    productQueue: <ProductQueue />,
    reports: <Reports />,
    sales: <Sales />,
    tae: <TAE />,
    training: <Training />,
    trainingProgress: <TrainingProgress />,
    userShield: <UserShieldIcon />,
    quotes: <Quotes />,
    workOrders: <WorkOrders />
};
